import { ConfigProvider, DatePicker } from 'antd';
import dayjs from 'dayjs';
import moment, { Moment } from 'moment';

const { RangePicker } = DatePicker;

type Props = {
  value?: { startTime: Moment; endTime: Moment | null };
  onChange?: (value: { startTime: Moment; endTime: Moment | null }) => void;
};
const RangerPickerDayOffs = ({ value, onChange }: Props) => {
  const startTime = dayjs(value?.startTime?.toDate());
  const endTime = dayjs(value?.endTime?.toDate());

  return (
    <ConfigProvider
      theme={{
        components: {
          DatePicker: {
            fontSize: 22,
          },
        },
      }}
    >
      <RangePicker
        disabledDate={(current) => {
          return current && current < dayjs().endOf('day');
        }}
        placeholder={['Start date', 'End date']}
        value={[startTime, endTime]}
        onChange={(vals) => {
          if (!vals) return;
          const newStartTime = moment(dayjs(vals[0]).format('MM-DD-YYYY'));
          const newEndTime = moment(dayjs(vals[1]).format('MM-DD-YYYY'));
          onChange?.({
            startTime: newStartTime,
            endTime: newEndTime,
          });
        }}
      />
    </ConfigProvider>
  );
};

export default RangerPickerDayOffs;
